const data = {
  primaryColor: "#FF5722",
  lightColor: false,
  title: "Notice Boards",
  category: "Productivity",
  icon: "/images/app-icons/notice-boards.png",
  slogan:
    "Write your notes, checklist, drawings and reminders and put them in boards",
  shortDescription:
    "",
  fullDescription: "Powerful tool for productivity with rich functions.",
  usesCases: [
    "Creating notes of your knowledge or for school",
    "Create checklist for shopping",
  ],
  properties: [
    "Creating notes, checklists, drawings, tasks",
    "Add tags and reminders to your notes",
    "Change colors of your notes and pin them to the top of your board",
    "Rich text editor for your notes",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: null,
    requirements:
      "This application does not need any special requirements to run.",
    requiredAndroidVersion: "5.0 and up",
    versioning: {
      releasedOn: null,
      currentVersion: "0.10.1-beta",
      updatedOn: null,
    },
    availableOn: {
      googlePlayURL: null,
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: "SQLite",
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [],
  },
  frontend: {
    url: null,
    versioning: {
      releasedOn: null,
      currentVersion: "0.5.19-beta",
      updatedOn: null,
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [],
  },
  backend: {
    versioning: {
      releasedOn: null,
      currentVersion: "0.10.5-beta",
      updatedOn: null,
    },
    techInformation: {
      language: "Java 17",
      framework: "Spring Boot 2.7.1",
      logging: "Log4j2",
      metrics: "Spring Boot Actuator",
      virtualization: "Docker",
      containerOS: "openjdk:17.0.2-slim",
      deployed: "k3s cluster",
      database: "PostgreSQL",
      integrations: [],
    },
  },
};

class NoticeBoardProjectsData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "notice-board",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new NoticeBoardProjectsData();
